import React, {useState, useEffect, useCallback} from 'react';
import './App.css';
import ItemList from './components/ItemList';
import Nav from './components/Nav';
import Footer from './components/Footer';
import PropTypes from 'prop-types';
import Toolbar from '@material-ui/core/Toolbar';
import {makeStyles} from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import useScrollTrigger from '@material-ui/core/useScrollTrigger';
import Fab from '@material-ui/core/Fab';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import Zoom from '@material-ui/core/Zoom';
import {Helmet} from 'react-helmet';

console.log = console.warn = console.error = () => {};

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'fixed',
    bottom: theme.spacing(2),
    right: theme.spacing(2),
  },
}));

function ScrollTop(props) {
  const {children, window} = props;
  const classes = useStyles();
  // Note that you normally won't need to set the window ref as useScrollTrigger
  // will default to window.
  // This is only being set here because the demo is in an iframe.
  const trigger = useScrollTrigger({
    target: window ? window() : undefined,
    disableHysteresis: true,
    threshold: 100,
  });

  const handleClick = (event) => {
    const anchor = (event.target.ownerDocument || document).querySelector(
      '#back-to-top-anchor'
    );

    if (anchor) {
      anchor.scrollIntoView({behavior: 'smooth', block: 'center'});
    }
  };

  return (
    <Zoom in={trigger}>
      <div onClick={handleClick} role="presentation" className={classes.root}>
        {children}
      </div>
    </Zoom>
  );
}

ScrollTop.propTypes = {
  children: PropTypes.element.isRequired,
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
};

function App(props) {
  const size = useWindowSize();
  const [user, setUser] = useState(null);
  const [searchVal, setSearchVal] = useState('');
  const [sendSave, setSendSave] = useState(false);
  const [total, setTotal] = useState(0);
  const [toggles, setToggles] = React.useState({
    got: 0,
    sb: 0,
    tier: 0,
  });
  const confirm = (b) => {
    console.log(b, 'saved');
    setSendSave(false);
  };
  return (
    <React.Fragment>
      <Helmet>
        <link rel="icon" type="image/gif/png" href="./logo32.png" />
        <meta charset="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta name="theme-color" content="#000000" />
        <meta name="description" content="ROTMG Drops Tracker" />
        <link rel="apple-touch-icon" href="./logo32.png" />

        <link rel="manifest" href="%PUBLIC_URL%/manifest.json" />

        <title>DROPS TRACKER</title>
      </Helmet>
      <CssBaseline />
      <Nav
        size={size}
        user={user}
        callback={setUser}
        setSendSave={setSendSave}
        search={setSearchVal}
        total={total}
        toggles={toggles}
        setToggles={setToggles}
      />
      <Toolbar id="back-to-top-anchor" />
      <div>
        <ItemList
          size={size}
          user={user}
          sendSave={sendSave}
          confirmSave={confirm}
          searchVal={searchVal}
          toggles={toggles}
          setTotal={setTotal}
        />
        <Footer
          style={{
            position: 'absolute',
            bottom: '0',
            marginTop: '-5rem',
            height: '5rem',
          }}
        />
      </div>

      <ScrollTop {...props}>
        <Fab color="secondary" size="small" aria-label="scroll back to top">
          <KeyboardArrowUpIcon />
        </Fab>
      </ScrollTop>
    </React.Fragment>
  );
}

export default App;

function useWindowSize() {
  const isClient = typeof window === 'object';

  const getSize = useCallback(() => {
    return {
      width: isClient ? window.innerWidth : undefined,
      height: isClient ? window.innerHeight : undefined,
    };
  }, [isClient]);

  const [windowSize, setWindowSize] = useState(getSize);

  useEffect(() => {
    if (!isClient) {
      return false;
    }

    function handleResize() {
      setWindowSize(getSize());
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [getSize, isClient]); // Empty array ensures that effect is only run on mount and unmount

  return windowSize;
}
